module.exports = __webpack_public_path__ + "static/img/icon_ttx.ede5a73.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_ttx.png
// module id = 4EWp
// module chunks = 11